import { NgModule } from '@angular/core';
import {
  LOCAL_STORAGE,
  provideNgxWebstorage,
  SESSION_STORAGE,
  withLocalStorage,
  withNgxWebstorageConfig,
  withSessionStorage,
} from 'ngx-webstorage';

import { getLocalStorage, getSessionStorage } from '@shared/utilities/storage.utilities';

@NgModule({
  providers: [
    provideNgxWebstorage(
      withNgxWebstorageConfig({ prefix: 'zef', separator: '.' }),
      withLocalStorage(),
      withSessionStorage(),
    ),
    { provide: LOCAL_STORAGE, useFactory: getLocalStorage },
    { provide: SESSION_STORAGE, useFactory: getSessionStorage },
  ],
})
export class StorageModule {}
